import React, { useState } from 'react'
import AccordionItem from './AccordionItem'
import './style.scss'

const Accordion = ({ items, allowMultipleOpen = false, defaultOpenIndex = null, fixedHeight = null, alwaysOpen  = false, color = 'accent1' }) => {
  const [openIndexes, setOpenIndexes] = useState(() =>
    defaultOpenIndex !== null ? [defaultOpenIndex] : []
  )

  const toggleIndex = (index) => {
    setOpenIndexes((prev) => {
      const isOpen = prev.includes(index)

      if (allowMultipleOpen) {
        if (isOpen) {
          if (alwaysOpen && prev.length === 1) return prev
          return prev.filter((i) => i !== index)
        } else {
          return [...prev, index]
        }
      } else {
        if (isOpen) {
          if (alwaysOpen) return prev
          return []
        } else {
          return [index]
        }
      }
    })
  }

  return (
    <div className='viso-accordion'>
      {items.map((item, index) => {
        const isOpen = openIndexes.includes(index)
        
        return (
          <AccordionItem
            key={index}
            title={item.title}
            content={item.content}
            isOpen={isOpen}
            onClick={() => toggleIndex(index)}
            fixedHeight={fixedHeight}
            contentRenderer={item.contentRenderer}
            color={color}
          />
        )
      })}
    </div>
  )
}

export default Accordion